import React from "react"
import { Modal } from "@mimber/ui-web"
import { RecordPaymentForm } from "@/components/forms/RecordPaymentForm"
import type { RecordPaymentModalProps } from "./RecordPaymentModal.types"

export const RecordPaymentModal: React.FunctionComponent<
  RecordPaymentModalProps
> = ({ invoiceUuid, onSuccess, ...modalProps }) => {
  return (
    <Modal footer={null} title="Record Payment" {...modalProps}>
      {(close) => (
        <RecordPaymentForm
          invoiceUuid={invoiceUuid}
          onSuccess={() => {
            close()
            onSuccess?.()
          }}
        />
      )}
    </Modal>
  )
}
